import React, { useEffect } from 'react';

import Router from './route/Router';

import './assets/styles/main.scss'
import ScrollToTop from './presentation/component/button/ScrollToTop'
import Authentication from './oauth/Authentication'
import FormGateway from './gateway/Form/FormGateway';

const App: React.FC = () => {
  useEffect(() => {
    Authentication.isLogged().then(isLogged => {
      if (isLogged) {
        Authentication.refreshProfile()
        new FormGateway().getForms()
      }
    })
  }, [])

  return <>
    <Router/>
    <ScrollToTop />
  </>
};

export default App;
